import datalayer from '../helpers/datalayer'

class ALink {
  constructor (el) {
    this.link = el

    this.init()
  }

  init () {
    // there will only ever be one link in each atom
    this.link.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()

      if (this.link.dataset.productHandle) {
        return new Promise((resolve, reject) => {
          datalayer.getProductByHandle(this.link.dataset.productHandle)
            .then((response) => {
              // console.log('Link product click data response:', response)
              return response
            })
            .then((data) => {
              // console.log('Link product click data resolve:', data)

              datalayer.pushProductClickEvent(data, this.link.dataset.productList, this.link.dataset.productPosition, this.link.href)

              resolve()
            })
            .catch((err) => {
              console.error('Link product click error:', err)

              reject(err)
            })
        })
      }
    })
  }
}

window.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-a-link]:not([ref="noProductClick"')
    .forEach(el => new ALink(el))
})
